import React, { useState, useEffect, createContext, useContext } from 'react';
import { GET_GROWER_BY_URN, UPDATE_GROWER, GET_STAKEHOLDER_BY_URN, ResourceUpdateMember, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../../common/URLs'
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { APPLICATION_ADDRESS_EVIDENCE, EXISTING_OCC, BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, GENDER, HIGHEST_QUALIFICATION, MOA_REGISTRATION_CERTIFICATE, SALUTATION, DATE_RANGE_ERROR, API_DATE_FORMAT, EMPTY_FIELD_ERROR, PROD, RESOURCE_ROLES, BANK_CANCELLED_CHEQUE, ROLES, LAND_DOCUMENT, LAND_AREA_UNIT, GEOCODE_LOCATION, GST, LOI_ABRPL_AGREEMENT, NON_ENCUMBRANCE_CERTI, VALATION_REPORT, BTWN_100_500_METER, BTWN_4_6_HR, BTWN_500_1_METER, BTWN_6_8_HR, MORE_THAN_8_HR, ROAD_PHOTO, LESS_THAN_2_FEET, MORE_THAN_2_FEET, LONGITUDE_ERROR, LATITUDE_ERROR, ID_PROOF, SEARCH_ICON_ERROR, CONTACT_PERSON_FIRST_NAME_ERROR, } from '../../../../common/constants';
import { toast } from 'react-toastify';
import { getAllComments, insertComment } from '../commonRegistrationStakeholderAPIs';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { GetRecentCommentObject, handleNumberFieldFocus } from '../../../../common/commonFunction';
import BackButton from '../../../../common/backButton';
import { Button, Box, Typography, Grid, Stack, InputLabel, ToggleButton, ToggleButtonGroup, FormHelperText, IconButton, InputAdornment, Container, FormControlLabel, FormControl, Switch, FormGroup, Select, Radio, RadioGroup, MenuItem, FormLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { VALIDATION, approverCommentMaxLength, bankAccountNumber, emailUrnPassMaxLength, govtIDcardLength, landAreaValidation, lastFourDigit, mobileNoMaxLength, mobileNumberValidation, pincodeValidation } from '../../../../common/commonValidations';
import Preview from '../preview';
import { TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import Badge from 'react-bootstrap/Badge';
import { FileUploadMUI } from '../../../../common/fileUpload/fileUploadMUI';
import { LocationPointMUI } from '../../../../common/locationPoints/locationPointMUI';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { addressMaxLength, maxNameLength, nameValidation, typeNumberValid } from '../../../../common/commonValidations';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ADDRESS_ERROR, APPLICANT_ERROR, BASIC_DATE_FORMAT, CONSTANTS, GOV_ID_LIST, INVALID_OTP_ERROR, LAND_AREA_ERROR, MOBILE_NO_ERROR, PINCODE_NO_ERROR, VALID_NAME_OF_APPLICANT_ERROR, WITHIN_100_METER } from '../../../../common/constants';
import resolveIcon from "../../../../images/resolved.png";
import { GET_ADDRESS_BY_IFSC, UPDATE_TEMPORARY_STORAGE, authKey } from '../../../../common/URLs';
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { PreviewIcon, SaveIcon } from '../../../../common/icons';
import _ from 'lodash';
import { appInsights } from '../../../../AppInsights';
import apiClient from '../../../../axios';
import BadgeComponent from '../../../../common/badge';
import CommentIcon from '@mui/icons-material/Comment';


const TempStorageContext = createContext();

function RegistrationDetailsTempStorage(props) {
    const { state } = useLocation();
    const urn = state?.URN ? state.URN : props.urn;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [characterLimit] = useState(300);
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [roadConnectivity, setRoadConnectivity] = useState("Adjacent to an existing bitumen/block road");
    const [optedLocationPowerConnectionDistance, setOptedLocationPowerConnectionDistance] = useState(WITHIN_100_METER);
    const [daytimePowerAvailability, setDaytimePowerAvailability] = useState(MORE_THAN_8_HR);
    const [landArea, setLandArea] = useState('');
    const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [bankDetails, setBankDetails] = useState();
    const [agreementStartDateDisplay, setAgreementStartDateDisplay] = useState();
    const [agreementEndDateDisplay, setAgreementEndDateDisplay] = useState();
    const [ownershipType, setOwnershipType] = useState("Owned");
    const [landFillingRequired, setLandFillingRequired] = useState(false);
    const [updateResponse, setUpdateResponse] = useState();
    const [documentArray, setDocumentArray] = useState([]);
    const [registrationtrue, setRegistrationtrue] = useState();
    const [isMSMERadio, setIsMSMERadio] = useState("NO");
    const [msmeCategory, setMsmeCategory] = useState("");
    const MSME_CATEGORY_OPTIONS = [
        { key: "MSM1", description: "Micro:Goods Mnfg/Spl" },
        { key: "MSM2", description: "Micro:Service Provdr" },
        { key: "MSM3", description: "Small:Goods Mnfg/Spl" },
        { key: "MSM4", description: "Small:Service Provdr" },
        { key: "MSM5", description: "Medium:Good Mnfg/Spl" },
        { key: "MSM6", description: "Medium:Service Provdr" },
        { key: "MSM7", description: "Other:Goods Mnfg/Spl" },
        { key: "MSM8", description: "Other:Service Provdr" },
        { key: "OTHER", description: "Others" }
    ];

    useEffect(() => {
        if (selectedApplicant === "Individual") {
            setIsMSMERadio("NO");
            setMsmeCategory("");
        }
    }, [selectedApplicant]);

    const initialData = {
        id: "",
        name: "",
        contactPersonName: "",
        contactPersonFirstname: "",
        contactPersonMiddlename: "",
        contactPersonLastname: "",
        contactPersonGender: GENDER[0],
        contactPersonSalutation: SALUTATION[0],
        mobileNo: "",
        isOtpValidated: mobileOTPValidated,
        bankAccountNumber: "",
        bankAccountHolderName: "",
        bankBranch: "",
        bankIfscCode: "",
        panNumber: "",
        govtIdCardType: "Aadhaar ID",
        govtIdCardNumber: "",
        otherGovtCardType: "",
        emailId: "",
        category: "",
        urn: "",
        preregistrationShortlisted: true,
        registrationStatus: "",
        scrutinyStatus: "",
        stakeholderStatus: true,
        createdOn: "",
        createdBy: "",
        updatedOn: "",
        updatedBy: "",
        isActive: 0,
        temporaryStorageDetail: {
            id: "",
            regStakeholderMasterId: "",
            officeAddress: "",
            officeDistrict: "",
            officeSubDivision: "",
            officeState: "",
            officePincode: "",
            officeRevenueCircle: "",
            officeBlockName: "",
            typeOfApplicant: "",
            landArea: "",
            landAreaUnit: LAND_AREA_UNIT[0],
            longitude: "",
            latitude: "",
            netWorth: "",
            storagePincode: "",
            storageAddress: "",
            storageState: "",
            storageDistrict: "",
            storageRevenueCircle: "",
            storageBlockName: "",
            storageSubDivision: "",
            workingCapital: "",
            isRoadConnectivityValid: true,
            roadConnectivity: "",
            optedLocationPowerConnectionDistance: "",
            isAlternatePowerSupplyAvailable: true,
            daytimePowerAvailability: "",
            gstNumber: "",
            nonEncumbranceCertificateNo: "",
            agreementStartDate: '',
            agreementEndDate: '',
            locationGeotag: "",
            ownershipType: "Owned",
            landFillingRequired: false,
            landFillingType: "",
            existingBoundaryWall: false,
            isExistingInfrastructure: false,
            createdOn: "",
            createdBy: "",
            updatedOn: "",
            updatedBy: "",
            isActive: 0,
            documents: []
        }
    }
    const initialError = {
        fullNameError: '',
        contactPersonNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        addressError: '',
        emailIdError: '',
        netWorthError: '',
        workingCapitalError: '',
        locationPincodeError: '',
        locationSearchError: '',
        locationAddressError: '',
        landAreaError: '',
        latitudesError: '',
        longitudesError: '',
        OTPError: '',
        OTPSentError: '',
        bankAccountError: '',
        accountHolderNameError: '',
        ifscError: '',
        bankBranchError: '',
        agreementSatrtDateError: '',
        agreementEndDateError: '',
        gstError: '',
        nonEncumCertError: '',
        documentError: '',
        panNumberError: '',
        idProofDocError: '',
        idCardNumberError: '',
        bankDocError: '',
        gstDocError: '',
        nonEncumDocError: '',
        valuationDocError: '',
        agreementDocError: '',
        locationDocError: '',
        landDocError: '',
        documentError: '',
        panDocError: '',
        otherCardError: ''
    }
    const [details, setDetails] = useState(initialData);
    const [storageDetails, setstorageDetails] = useState();
    const [storageError, setStorageError] = useState('');
    const [otpValue, setOtpValue] = useState()
    const [checkTermChecked, setCheckTermChecked] = useState(false);
    const [checkTermDisable, setCheckTermDisable] = useState(false);
    const [loc, setLoc] = useState();
    const [commentsData, setCommentsData] = useState();
    const [comments, setComments] = useState([]);
    let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
    let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
    let agreementComments = comments?.filter((item) => item.sectionName === "agreement_details");
    let financeComments = comments?.filter((item) => item.sectionName === "finance_details");
    let locationComments = comments?.filter((item) => item.sectionName === "location_details");
    const [personalComment, setPersonalComment] = useState("");
    const [bankComment, setBankComment] = useState("");
    const [agreementComment, setAgreementComment] = useState("");
    const [financeComment, setFinanceComment] = useState("");
    const [locationComment, setLocationComment] = useState("");
    const decoded = jwt(getLocalStorageItem('id_token'));
    let userRole = localStorage.getItem('role');
    let uuid = localStorage.getItem('uuid');
    const [expandedSection, setExpandedSection] = useState("personal");
    const bambooSpeciesRes = props.bambooSpeciesRes;

    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        addressError: '',
        emailIdError: '',
        netWorthError: '',
        workingCapitalError: '',
        locationPincodeError: '',
        locationSearchError: '',
        locationAddressError: '',
        landAreaError: '',
        latitudesError: '',
        longitudesError: '',
        OTPError: '',
        OTPSentError: '',
        bankAccountError: '',
        accountHolderNameError: '',
        ifscError: '',
        bankBranchError: '',
        agreementSatrtDateError: '',
        agreementEndDateError: '',
        gstError: '',
        nonEncumCertError: '',
        documentError: '',
        panNumberError: '',
        idProofDocError: '',
        idCardNumberError: '',
        bankDocError: '',
        gstDocError: '',
        nonEncumDocError: '',
        valuationDocError: '',
        agreementDocError: '',
        locationDocError: '',
        landDocError: '',
        documentError: '',
        panDocError: '',
        otherCardError: ''
    });

    const [currentPage, setCurrentPage] = useState("registrationDetailsTempStorage");
    const [buttonAction, setButtonAction] = useState("");
    const [callUpdateApi, setCallUpdateApi] = useState(false);
    const [showCommentSection, setShowCommentSection] = useState(false);
    const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
    const [stakeHolderDetails, setStakeHolderDetails] = useState();
    const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
    const [showClarificationButton, setShowClarificationButton] = useState(false);
    const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
    const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
    const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
    const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
    const [financeDetailsSectionOk, setFinanceDetailsSectionOk] = useState(false);
    const [locationDetailsSectionOk, setLocationDetailsSectionOk] = useState(false);
    const [shouldActOnSection, setShouldActOnSection] = useState({
        personal_details: false,
        bank_details: false,
        agreement_details: false,
        finance_details: false,
        location_details: false
    })
    const [callWorkFlowApi, setCallWorkFlowApi] = useState(false);

    const enableFieldFunction = (sectionEnabled, isPreg, isNew) => {
        if (state?.viewOnly) {
            return false
        }
        if (userRole === ROLES.ItAdmin) {
            return true
        }
        if (
            userRole === ROLES.RegistrationScruitnizer &&
            state?.userType === "Internal"
        ) { return true; }
        else if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
            return true
        }
        else if (isNew) {
            return true
        }
        else return false
    }

    const onApplicantClick = (e) => {
        e.preventDefault()
        setSelectedApplicant(e.target.value)
        if (e.target.value == "Individual") {
            setDetails({ ...details, govtIdCardType: "Aadhaar ID", govtIdCardNumber: "" })
        }
        if (e.target.value != "Individual") {
            setDetails({ ...details, govtIdCardType: "MOA" })
        }
    }

    useEffect(() => {
        const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
        setComments(commentsData);
        let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
        let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
        let agreementCommentsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
        let financeDetailsInitial = commentsData?.filter((item) => item.sectionName === "finance_details");
        let locationDetailsInitial = commentsData?.filter((item) => item.sectionName === "location_details");
        setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
        setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
        setAgreementDetailsSectionOk(GetRecentCommentObject(agreementCommentsInitial)?.sectionOk ? GetRecentCommentObject(agreementCommentsInitial)?.sectionOk : false);
        setFinanceDetailsSectionOk(GetRecentCommentObject(financeDetailsInitial)?.sectionOk ? GetRecentCommentObject(financeDetailsInitial)?.sectionOk : false);
        setLocationDetailsSectionOk(GetRecentCommentObject(locationDetailsInitial)?.sectionOk ? GetRecentCommentObject(locationDetailsInitial)?.sectionOk : false);
        if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = false;
            });
        }
        else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = false;
            });
        }
        else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
            Object.keys(shouldActOnSection).forEach(key => {
                const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
                shouldActOnSection[key] = !section?.sectionOk;
            });
        }
        else {
            Object.keys(shouldActOnSection).forEach(key => {
                shouldActOnSection[key] = true;
            });
        }
    }, [commentsData]);

    useEffect(() => {
        if (urn) {
            getStakeholderDetailsFromUrn();
        }
    }, [urn]);

    useEffect(() => {
        if (callUpdateApi) {
            appInsights.trackEvent({
                name: 'Details Changed',
                properties: {
                    timeStamp: new Date().toISOString(),
                    user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
                }
            })
            if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
                onCheckUserDistrictMapping();
            }
            else updateTempstorage();
        }
    }, [callUpdateApi]);

    const onCheckUserDistrictMapping = () => {
        loaderService.showLoader();
        apiClient.post(CHECK_USER_DISTRICT_MAPPING,
            {
                "state": stakeHolderDetails?.temporaryStorageMasters?.[0]?.state,
                "plotDistrict": stakeHolderDetails?.temporaryStorageMasters?.[0]?.district
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    updateTempstorage();
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const getStakeholderDetailsFromUrn = () => {
        loaderService.showLoader();
        apiClient.post(GET_STAKEHOLDER_BY_URN,
            {
                "urn": urn,
                "includeRejected": true
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                loaderService.hideLoader();
                let stakeHolderDetailsLocal = response.data.stakeHolder;
                setStakeHolderDetails(response.data.stakeHolder);
                const data = response.data.stakeHolder;
                setDetails({ ...data, temporaryStorageDetail: { ...data.temporaryStorageMasters[0], agreementStartDate: data.temporaryStorageMasters[0].agreementStartDate, agreementEndDate: data.temporaryStorageMasters[0].agreementEndDate }, govtIdCardType: data.govtIdCardType ? data.govtIdCardType : data.temporaryStorageMasters[0].typeOfApplicant == "Individual" ? "Aadhaar ID" : "MOA" });
                const spaceIndex = data.temporaryStorageMasters[0].landArea?.indexOf(" ");
                const numberPart = data.temporaryStorageMasters[0].landArea?.slice(0, spaceIndex);
                const unitPart = data.temporaryStorageMasters[0].landArea?.slice(spaceIndex + 1);
                setAgreementStartDateDisplay(data.temporaryStorageMasters[0].agreementStartDate && moment(data.temporaryStorageMasters[0].agreementStartDate).format(BASIC_DATE_FORMAT))
                setAgreementEndDateDisplay(data.temporaryStorageMasters[0].agreementEndDate && moment(data.temporaryStorageMasters[0].agreementEndDate).format(BASIC_DATE_FORMAT))
                setLandArea(numberPart);
                setLandAreaUnit(unitPart);
                setMobileOTPValidated(data.isOtpValidated);
                setRoadConnectivity(data.temporaryStorageMasters[0].roadConnectivity);
                setDaytimePowerAvailability(data.temporaryStorageMasters[0].daytimePowerAvailability);
                setOptedLocationPowerConnectionDistance(data.temporaryStorageMasters[0].optedLocationPowerConnectionDistance);
                setDocumentArray(data.temporaryStorageMasters[0].documents);
                setSelectedApplicant(data.temporaryStorageMasters[0].typeOfApplicant);
                setRegistrationtrue(data?.registrationCompleted);
                setIsMSMERadio(data?.isMSME === 1 ? "YES" : "NO");
                setMsmeCategory(data?.msmeCategory || "");
                if (stakeHolderDetailsLocal) {
                    const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid
                    if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
                        &&
                        (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)
                    ) {
                        setShowCommentSection(true);
                    }
                    if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
                        setShowCommentSection(true);
                        setRegScruResourceUpdate(true);
                    }
                    if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected" && (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated"))) || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && !stakeHolderDetailsLocal?.registrationCompleted) || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved"))) {
                        setEnableSaveSubmitButtons(true);
                    }
                    if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
                        // && state?.registerByScruOtpValidated for otp validation in pending clarification add after userole in below line
                        if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus == "Pending_Clarification") {
                            setShowClarificationButton(true);
                            setEnableSaveSubmitButtons(true);
                        }
                        if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus != "Pending_Clarification")) {
                            setShowWorkFlowButtons(true);
                        }
                    }
                    getAllComments(data?.temporaryStorageMasters[0]?.regStakeholderMasterId, setCommentsData);
                }
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });

    }

    const onSaveComment = (comment, sectionName, sectionOk) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: details?.temporaryStorageDetail?.regStakeholderMasterId,
            sectionName: sectionName,
            sectionId: details?.temporaryStorageDetail?.id,
            sectionOk: sectionOk,
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid,
        }
        comment ? insertComment([commentObject], details?.temporaryStorageDetail?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
        setPersonalComment("");
        setBankComment("")
        setAgreementComment("");
        setFinanceComment("");
        setLocationComment("");
        setErrorMessage({ ...errorMessage, personalCommentError: "", bankCommentError: "", agreementCommentError: "", financeCommentError: "", locationCommentError: "" })
    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const getSubmit = () => {
        if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
            return true
        }
        else {
            return false
        }
    }

    function getBankDetails() {
        apiClient
            .post(GET_ADDRESS_BY_IFSC,
                {
                    "ifsc": details.bankIfscCode,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    setBankDetails(response.data);
                    setErrorMessage({ ...errorMessage, ifscCodeError: "" });
                }
                else {
                    setDetails({
                        ...details, bankBranch: " ", bankIfscCode: " ",
                    });

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const setOfficeAddressData = (data) => {
        setErrorMessage({ ...errorMessage, pincodeError: "" })
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    officePincode: data.pincode,
                    officeState: data.pincodeState,
                    officeDistrict: data.pincodeDistrict,
                    officeSubDivision: data.pincodeSubDivision,
                    officeRevenueCircle: data.selectedRevenueCircle,
                    officeBlockName: data.selectedBlockName
                }
            };
        });
    }
    const handleOfficeChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, officeBlockName: e.target.value } };
            });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, officeRevenueCircle: e.target.value } };
            });
        }
    }
    const setStorageAddressData = (data) => {
        setErrorMessage({ ...errorMessage, locationPincodeError: "" })
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    storagePincode: data.pincode,
                    storageState: data.pincodeState,
                    storageDistrict: data.pincodeDistrict,
                    storageSubDivision: data.pincodeSubDivision,
                    storageRevenueCircle: data.selectedRevenueCircle,
                    storageBlockName: data.selectedBlockName
                }
            };
        });
    }
    const handleStorageChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, storageBlockName: e.target.value } };
            });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, storageRevenueCircle: e.target.value } };
            });
        }
    }

    const handleDateChange = (e, name) => {
        // e.preventDefault()
        //console.log("e", e.format("YYYY-MM-DD"))
        let selectedDate = e.format(BASIC_DATE_FORMAT)
        let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        if (name == "startDate") {
            setAgreementStartDateDisplay(selectedDate);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, agreementStartDate: formattedDate } };
            });
        }
        else {
            setAgreementEndDateDisplay(selectedDate);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, agreementEndDate: formattedDate } };
            });
        }
    }

    useEffect(() => {
        if (bankDetails) {
            setDetails({
                ...details, bankBranch: bankDetails?.branch
            });
        }
    }, [bankDetails]);

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }

    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", OTPError: "", acceptTermError: "" })
            setVerifyMobileNo(true);
            setOtpHidden(false);
        }

    }

    const callbackIFSCCheck = (response) => {
        if (response.isSuccess) {
            setDetails({ ...details, bankBranch: response.branch })
        }

    }

    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }

    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "", OTPError: "", mobileNoError: "", acceptTermError: "" });
        if (response.isSuccess) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setDetails({ ...details, isOtpValidated: true })
        }
        else {
            setErrorMessage({ ...errorMessage, OTPError: INVALID_OTP_ERROR });
        }
    }

    const onLocationPoint = (position) => {
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    latitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
                    longitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
                }
            };
        });
    }

    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const roadConnectivityChange = (e) => {
        setRoadConnectivity(e.target.value)
    }
    const optedLocationPowerConnectionDistanceChnage = (e) => {
        setOptedLocationPowerConnectionDistance(e.target.value)
    }
    const onDaytimePowerAvailabilityChange = (e) => {
        setDaytimePowerAvailability(e.target.value)
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
        setDetails(current => {
            return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, documents: docArray } };
        });
    }
    const handleChange = (e) => {

        if (e.target.name === "fullName") {

            // 1) Clean + limit:

            const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, 100);

            // 2) Save cleaned value only once:

            setDetails({

                ...details,

                [e.target.name]: cleanedValue

            });

            // 3) Validate cleaned value:

            if (cleanedValue.length > 0) {

                const Fullname_regex = /^[a-zA-Z0-9&/ ]+$/;

                if (!Fullname_regex.test(cleanedValue)) {

                    setErrorMessage({

                        ...errorMessage,

                        fullNameError: "Please provide valid Name"

                    });

                } else {

                    setErrorMessage({

                        ...errorMessage,

                        fullNameError: ""

                    });

                }

            } else {

                setErrorMessage({

                    ...errorMessage,

                    fullNameError: "Please enter Name of Applicant"

                });

            }

        } else {

            // For other fields, normal update:

            setDetails({

                ...details,

                [e.target.name]: e.target.value

            });

        }

        if (e.target.name === "contactPersonGender" || e.target.name === "contactPersonSalutation") {
            setDetails({ ...details, [e.target.name]: e.target.value });
        }
        if (e.target.name === "bankBranch") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, ifscError: "" })
            } else {
                setErrorMessage({ ...errorMessage, ifscError: "Please search IFSC code" })

            }
            setDetails({ ...details, [e.target.name]: e.target.value });
        }

        if (e.target.name === 'bankIfscCode') {
            setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
            if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, ifscError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value, bankBranch: "" });
            } else setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC Code" })
        }

        if (e.target.name === "bankAccountNumber") {
            const limit = 18;
            if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.toUpperCase().slice(0, limit))) {
                setErrorMessage({ ...errorMessage, bankAccountError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) });
            } else {
                setErrorMessage({ ...errorMessage, bankAccountError: 'Please enter valid Account Number' })

            }
        }
        if (e.target.name === "bankAccountHolderName") {
            setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })

            }
        }
        if (e.target.name === 'otherGovtCardType') {
            const limit = 50;
            if (e.target.value.length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.toUpperCase()).slice(0, limit) });
                setErrorMessage({ ...errorMessage, otherCardError: '' })
            }
            else {
                setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
            }
        }
        if (e.target.name === "officeAddress") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 300)) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else {
                setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })

            }

        }

        if (e.target.name === "contactPersonFirstname") {
            const Firstname_regex = /^[a-zA-Z]+$/;
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if (!(details.contactPersonFirstname.match(Firstname_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonNameError: VALID_NAME_OF_APPLICANT_ERROR })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
            }
        }
        if (e.target.name === "contactPersonMiddlename") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === "contactPersonLastname") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === "mobileNo") {
            var slicedMobileNumber = mobileNumberValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedMobileNumber })
            if (slicedMobileNumber.length != 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name === "officePincode") {
            var slicedPincode = pincodeValidation(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
            if (slicedPincode.length != 6) {
                setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
        if (e.target.name === "storagePincode") {
            var slicedPincode = pincodeValidation(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
            if (slicedPincode.length != 6) {
                setErrorMessage({ ...errorMessage, locationPincodeError: PINCODE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationPincodeError: '' });
        }
        if (e.target.name === "emailId") {
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, 50) })
            if ((e.target.value).length > 0) {
                if (isValidEmail(e.target.value)) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter a valid Email Address" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "netWorth") {
            const limit = 10;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, netWorthError: "" })
            } else {
                setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" })

            }
        }
        if (e.target.name === "workingCapital") {
            const limit = 10;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, workingCapitalError: "" })
            } else {
                setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" })

            }
        }
        if (e.target.name === "storageAddress") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationAddressError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 300)) }, };
            });
        }
        if (e.target.name === "landArea") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setLandArea(slicedLandArea);
            if (slicedLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, landAreaError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: slicedLandArea + ' ' + landAreaUnit }, };
            });
        }
        if (e.target.name === "landAreaUnit") {
            setLandAreaUnit(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: landArea + ' ' + e.target.value }, };
            });
        }
        if (e.target.name === "latitude") {
            const limit = 18;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, latitudeError: "" })
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
                });

            } else {
                setErrorMessage({ ...errorMessage, latitudeError: "Please enter valid latitude" })

            }
        }
        if (e.target.name === "longitude") {
            const limit = 18;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            }); if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, longitudesError: "" })
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
                });

            } else {
                setErrorMessage({ ...errorMessage, longitudesError: "Please enter valid longitude" })

            }
        }
        if (e.target.name === "gstNumber") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.toUpperCase() }, };
            });
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, gstError: "Please enter GST Number" });
            }
            else {
                if (e.target.value.length > 0 && VALIDATION.gstNumberValidation(e.target.value)) {
                    setErrorMessage({ ...errorMessage, gstError: "" });
                } else setErrorMessage({ ...errorMessage, gstError: 'Invalid GST Number' })
            }
        }
        if (e.target.name === "nonEncumbranceCertificateNo") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, nonEncumCertError: "Please enter non encumbrance certificate no" });
            }
            else setErrorMessage({ ...errorMessage, nonEncumCertError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.toUpperCase().slice(0, 50)) }, };
            });
        }
        if (e.target.name === "panNumber" || e.target.name === "govtIdCardType" || e.target.name === "govtIdCardNumber") {
            if (e.target.name === "panNumber") {
                setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') },)
                // setDetails(current => {
                //     return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.replace(/[^a-zA-Z0-9]/gi, '') }, };
                // });
                if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value)) {
                    setErrorMessage({ ...errorMessage, panNumberError: "" })
                    setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase() },)
                    // setDetails(current => {
                    //     return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
                    // });
                } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
            }
            else if (e.target.name === "govtIdCardNumber") {
                setErrorMessage({ ...errorMessage, idCardNumberError: "" })
                if (details.govtIdCardType == "Aadhaar ID") {
                    var govtIDNumber = e.target.value.replace(/[^0-9]/gi, '').slice(0, 4);
                    setDetails({ ...details, [e.target.name]: govtIDNumber })
                }
                else
                    setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().slice(0, (details.govtIdCardType === "Registration Certificate" || details.govtIdCardType === "MOA") ? 30 : 20) })
            }
            else
                setDetails({ ...details, [e.target.name]: e.target.value })
        }
        if (e.target.name === "agreeementStartDate") {
            if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
            }
            else {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "" });
            }
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
        }
        if (e.target.name === "agreementEndDate") {
            if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
            }
            else {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "" });
            }
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
        }
        if (e.target.name === "existingInfrastructureOnPlot") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationAddressError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) }, };
            });
        }
    }
    const onRadioButtonClick = (e) => {
        if (e.target.name == "Owned_type") {
            setOwnershipType(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, "ownershipType": e.target.value }, };
            });
        }
        else if (e.target.name == "landFillingRequired") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, landFillingRequired: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, landFillingRequired
                                : false
                        },
                    };
                });
        }
        else if (e.target.name == "landFillingType") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, "landFillingType": e.target.value }, };
            });
        }
        else if (e.target.name == "existingBoundary") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, existingBoundaryWall: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, existingBoundaryWall
                                : false
                        },
                    };
                });
        }
        else if (e.target.name == "isExistingInfrastructure") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, isExistingInfrastructure: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, isExistingInfrastructure
                                : false
                        },
                    };
                });
        }
    }

    const validateDetails = () => {
        var bankdoc = documentArray && documentArray.filter((item) => item.documentType === BANK_CANCELLED_CHEQUE && (item.isActive == 1 || item.isActive == 3));
        var gstdoc = documentArray && documentArray.filter((item) => item.documentType === GST && (item.isActive == 1 || item.isActive == 3));
        if ((!details.name)) {
            setErrorMessage({ ...errorMessage, fullNameError: APPLICANT_ERROR });
            toast.error(APPLICANT_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (selectedApplicant !== "Individual" && isMSMERadio === "YES") {

            if (!msmeCategory) {
                toast.error("Please select MSME category");
                setExpandedSection("personal");
                return;
            }

            const msmeDoc = documentArray?.filter(
                d => d.documentType === "MSME_Certificate" &&
                    (d.isActive === 1 || d.isActive === 3)
            );

            if (!msmeDoc || msmeDoc.length === 0) {
                setErrorMessage({
                    ...errorMessage,
                    msmeDocError: "Please upload MSME certificate"
                });
                toast.error("Please upload MSME certificate");
                setExpandedSection("personal");
                return;
            }
        }
        else if (!details.contactPersonFirstname) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR });
            toast.error(CONTACT_PERSON_FIRST_NAME_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (!details.mobileNo || details.mobileNo.length != 10) {
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            toast.error(MOBILE_NO_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (!details.emailId || !isValidEmail(details.emailId)) {
            setErrorMessage({ ...errorMessage, emailIdError: "Please enter a valid Email Address" });
            toast.error("Please enter a valid Email Address");
            setExpandedSection("personal");
            return;
        }
        else if (!details.temporaryStorageDetail.officeAddress) {
            setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR });
            toast.error(ADDRESS_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (details.temporaryStorageDetail.officePincode.length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            toast.error(PINCODE_NO_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (!details.temporaryStorageDetail.officeState) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            toast.error(SEARCH_ICON_ERROR);
            setExpandedSection("personal");
            return;
        }
        else if (userRole !== ROLES.ItAdmin) {
            if (details.temporaryStorageDetail.panNumber && !VALIDATION.panNumberValidation(details.temporaryStorageDetail.panNumber)) {
                setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
                toast.error("Please enter valid PAN Number");
                setExpandedSection("personal");
                return;
            }
            else if (details.govtIdCardType == "Other" && !details?.otherGovtCardType) {
                setErrorMessage({ ...errorMessage, otherCardError: "Please enter Card Type" })
                toast.error("Please enter Card Type");
                setExpandedSection("personal");
                return;
            }
            else if ((!details.govtIdCardNumber || details.govtIdCardNumber?.length == 0)) {
                setErrorMessage({ ...errorMessage, idCardNumberError: "Please enter ID Proof Number" })
                toast.error("Please enter ID Proof Number");
                setExpandedSection("personal");
                return;
            }
            var idProofDoc = documentArray && documentArray.filter((item) => item.documentType === ID_PROOF && (item.isActive == 1 || item.isActive == 3));
            if ((!idProofDoc || idProofDoc.length == 0)) {
                setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
                toast.error("Please upload ID Proof document");
                setExpandedSection("personal");
                return;
            }
            else {
                setErrorMessage({ idProofDocError: "" });
            }
            if (!details.bankAccountNumber || details.bankAccountNumber.length == 0 && !(VALIDATION.bankAccountNumberValidation(details.bankAccountNumber))) {
                setErrorMessage({ ...errorMessage, bankAccountError: 'Please enter valid Account Number' });
                toast.error('Please enter valid Account Number');
                setExpandedSection("bank");
                return;
            }
            else if (!details.bankAccountHolderName || details.bankAccountHolderName.length == 0 && !(VALIDATION.bankAccountNameValidation(details.bankAccountHolderName))) {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" });
                toast.error("Please enter Account Holder's Name");
                setExpandedSection("bank");
                return;
            }
            else if (!details.bankIfscCode || details.bankIfscCode.length == 0 && !(VALIDATION.ifscValidation(details.bankIfscCode))) {
                setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC code." });
                toast.error("Please enter valid IFSC code.");
                setExpandedSection("bank");
                return;
            }
            else if (!details.bankBranch) {
                setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC code and search" });
                toast.error("Please enter valid IFSC code and search");
                setExpandedSection("bank");
                return;
            }
            else if (bankdoc.length == 0) {
                setErrorMessage({ bankDocError: "Please upload bank document" });
                toast.error("Please upload bank document");
                setExpandedSection("bank");
                return;
            }
            else if (!details.temporaryStorageDetail.gstNumber) {
                setErrorMessage({ ...errorMessage, gstError: "Please enter GST number" });
                toast.error("Please enter GST number");
                setExpandedSection("agreement");
                return;
            }
            else if (gstdoc.length == 0) {
                setErrorMessage({ gstDocError: "Please upload gst document" });
                toast.error("Please upload gst document");
                setExpandedSection("agreement");
                return;
            }
            else if (!details.temporaryStorageDetail.nonEncumbranceCertificateNo) {
                setErrorMessage({ ...errorMessage, nonEncumCertError: "Please enter non encumbrance certificate no" });
                toast.error("Please enter non encumbrance certificate no");
                setExpandedSection("agreement");
                return;
            } if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
                toast.error("Agreement Start Date can not be greater than Agreement End Date");
                setExpandedSection("agreement");
                return;
            }

            var nonEncumdoc = documentArray && documentArray.filter((item) => item.documentType === NON_ENCUMBRANCE_CERTI && (item.isActive == 1 || item.isActive == 3));
            if (nonEncumdoc.length == 0) {
                setErrorMessage({ nonEncumDocError: "Please upload non-encumbrance document" });
                toast.error("Please upload non-encumbrance document");
                setExpandedSection("agreement");
                return;
            }
            var valuationDoc = documentArray && documentArray.filter((item) => item.documentType === VALATION_REPORT && (item.isActive == 1 || item.isActive == 3));
            if (valuationDoc.length == 0) {
                setErrorMessage({ valuationDocError: "Please upload valuation document" });
                toast.error("Please upload valuation document");
                setExpandedSection("agreement");
                return;
            }
        }
        if (!details.temporaryStorageDetail.netWorth) {
            setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" });
            toast.error("Please enter Net Worth");
            setExpandedSection("finance");
            return;
        }
        else if (!details.temporaryStorageDetail.workingCapital) {
            setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" });
            toast.error("Please enter Working Capital");
            setExpandedSection("finance");
            return;
        }
        else if (!details.temporaryStorageDetail.storageAddress) {
            setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            toast.error(ADDRESS_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (details.temporaryStorageDetail.storagePincode.length != 6) {
            setErrorMessage({ ...errorMessage, locationPincodeError: PINCODE_NO_ERROR })
            toast.error(PINCODE_NO_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.storageState) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            toast.error(SEARCH_ICON_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.latitude) {
            setErrorMessage({ ...errorMessage, latitudesError: LATITUDE_ERROR });
            toast.error(LATITUDE_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.longitude) {
            setErrorMessage({ ...errorMessage, longitudesError: LONGITUDE_ERROR });
            toast.error(LONGITUDE_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.landArea) {
            setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            toast.error(LAND_AREA_ERROR);
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.latitude) {
            setErrorMessage({ latitudesError: "Please enter latitude" })
            toast.error("Please enter latitude");
            setExpandedSection("location");
            return;
        }
        else if (!details.temporaryStorageDetail.longitude) {
            setErrorMessage({ longitudesError: "Please enter longitude" })
            toast.error("Please enter longitude");
            setExpandedSection("location");
            return;
        }
        else if (!landArea || landArea.longitude == 0) {
            setErrorMessage({ landAreaError: "Please enter land area" })
            toast.error("Please enter land area");
            setExpandedSection("location");
            return;
        }
        var locationDoc = documentArray && documentArray.filter((item) => item.documentType === GEOCODE_LOCATION && (item.isActive == 1 || item.isActive == 3));
        if (locationDoc.length == 0) {
            setErrorMessage({ locationDocError: "Please upload land location image" });
            toast.error("Please upload land location image");
            setExpandedSection("location");
            return;
        }
        else {
            setErrorMessage({ locationDocError: "" });
        }
        var landDoc = documentArray && documentArray.filter((item) => item.documentType === LAND_DOCUMENT && (item.isActive == 1 || item.isActive == 3));
        if (landDoc.length == 0) {
            setErrorMessage({ landDocError: "Please upload land document" });
            toast.error("Please upload land document");
            setExpandedSection("location");
            return;
        }
        else {
            setErrorMessage({ landDocError: "" });
        }
        showPreview();
    }

    const noCommentForMandatorySections = () => {
        if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
            if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("personal");
                setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("bank");
                setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("agreement");
                setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (comments.find((item) => item.sectionName === "finance_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "finance_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("finance");
                setErrorMessage({ ...errorMessage, financeCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (comments.find((item) => item.sectionName === "location_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "location_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("location");
                setErrorMessage({ ...errorMessage, locationCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
        }
        else {
            if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("personal");
                setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("bank");
                setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("agreement");
                setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (shouldActOnSection.finance_details && !comments.find((item) => item.sectionName === "finance_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("finance");
                setErrorMessage({ ...errorMessage, financeCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
            if (shouldActOnSection.location_details && !comments.find((item) => item.sectionName === "location_details" && item.createdBy === (decoded.extension_URN ? details?.temporaryStorageDetail?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
                setExpandedSection("location");
                setErrorMessage({ ...errorMessage, locationCommentError: "Please enter comment and save" });
                // toast.error( "Please enter comment and save")
                return true;
            }
        }
        return false
    }


    const showPreview = () => {
        if (showCommentSection && (noCommentForMandatorySections())
        ) {
            toast.error("Please enter comments for required sections");
        }
        else {
            enableSaveSubmitButtons && !_.isEqual(finalData, initialDataCompare) ? setCallUpdateApi(true) : setCurrentPage("preview");
            setButtonAction("preview")
        }
    }

    const getRegistrationStatus = (submit) => {
        var regStatus = details?.registrationStatus;
        if (userRole != ROLES.ItAdmin) {
            if (details?.registrationStatus === "Approved" && userRole === RESOURCE_ROLES.PlantSCMMember || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal")) {
                regStatus = "ResourceUpdate_Initiated";
            }
        }
        return regStatus;
    }

    const initialDataCompare = {
        "id": stakeHolderDetails?.id,
        "name": stakeHolderDetails?.name,
        "contactPersonName": stakeHolderDetails?.contactPersonName,
        "contactPersonFirstname": stakeHolderDetails?.contactPersonFirstname,
        "contactPersonMiddlename": stakeHolderDetails?.contactPersonMiddlename,
        "contactPersonLastname": stakeHolderDetails?.contactPersonLastname,
        "contactPersonGender": stakeHolderDetails?.contactPersonGender,
        "contactPersonSalutation": stakeHolderDetails?.contactPersonSalutation,
        "mobileNo": stakeHolderDetails?.mobileNo,
        "bankAccountNumber": stakeHolderDetails?.bankAccountNumber,
        "bankAccountHolderName": stakeHolderDetails?.bankAccountHolderName,
        "bankBranch": stakeHolderDetails?.bankBranch,
        "bankIfscCode": stakeHolderDetails?.bankIfscCode,
        "bankName": stakeHolderDetails?.bankName,
        "panNumber": stakeHolderDetails?.panNumber,
        "govtIdCardType": stakeHolderDetails?.govtIdCardType,
        "govtIdCardNumber": stakeHolderDetails?.govtIdCardNumber,
        "otherGovtCardType": stakeHolderDetails?.otherGovtCardType,
        "emailId": stakeHolderDetails?.emailId,
        "category": stakeHolderDetails?.category,
        "categoryName": stakeHolderDetails?.categoryName,
        "urn": stakeHolderDetails?.urn,
        "growerType": stakeHolderDetails?.growerType,
        "isOtpValidated": stakeHolderDetails?.isOtpValidated,
        "preregistrationShortlisted": stakeHolderDetails?.preregistrationShortlisted,
        "registrationStatus": stakeHolderDetails?.registrationStatus,
        "scrutinyStatus": stakeHolderDetails?.scrutinyStatus,
        "stakeholderStatus": stakeHolderDetails?.stakeholderStatus,
        "adb2cOid": stakeHolderDetails?.adb2cOid,
        "createdOn": stakeHolderDetails?.createdOn,
        "createdBy": stakeHolderDetails?.createdBy,
        "updatedOn": stakeHolderDetails?.updatedOn,
        "updatedBy": stakeHolderDetails?.updatedBy,
        "isActive": stakeHolderDetails?.isActive,
        "registrationCompleted": stakeHolderDetails?.registrationCompleted,
        "registrationCompletedBy": stakeHolderDetails?.registrationCompletedBy,
        "sapVendorId": stakeHolderDetails?.sapVendorId,
        "lastUpdatedDate": stakeHolderDetails?.lastUpdatedDate,
        "currentOwnerID": stakeHolderDetails?.currentOwnerID,
        "subCategory": stakeHolderDetails?.subCategory,
        "acceptedTerms": stakeHolderDetails?.acceptedTerms,

        "temporaryStorageDetail": {
            "id": stakeHolderDetails?.temporaryStorageMasters[0]?.id,
            "regStakeholderMasterId": stakeHolderDetails?.temporaryStorageMasters[0]?.regStakeholderMasterId,
            "officeAddress": stakeHolderDetails?.temporaryStorageMasters[0]?.officeAddress,
            "officeDistrict": stakeHolderDetails?.temporaryStorageMasters[0]?.officeDistrict,
            "officeRevenueCircle": stakeHolderDetails?.temporaryStorageMasters[0]?.officeRevenueCircle,
            "officeBlockName": stakeHolderDetails?.temporaryStorageMasters[0]?.officeBlockName,
            "officeSubDivision": stakeHolderDetails?.temporaryStorageMasters[0]?.officeSubDivision,
            "officeState": stakeHolderDetails?.temporaryStorageMasters[0]?.officeState,
            "officePincode": stakeHolderDetails?.temporaryStorageMasters[0]?.officePincode,
            "typeOfApplicant": stakeHolderDetails?.temporaryStorageMasters[0]?.typeOfApplicant,
            "landArea": stakeHolderDetails?.temporaryStorageMasters[0]?.landArea,
            "longitude": stakeHolderDetails?.temporaryStorageMasters[0]?.longitude,
            "latitude": stakeHolderDetails?.temporaryStorageMasters[0]?.latitude,
            "netWorth": stakeHolderDetails?.temporaryStorageMasters[0]?.netWorth,
            "storagePincode": stakeHolderDetails?.temporaryStorageMasters[0]?.storagePincode,
            "storageAddress": stakeHolderDetails?.temporaryStorageMasters[0]?.storageAddress,
            "storageState": stakeHolderDetails?.temporaryStorageMasters[0]?.storageState,
            "storageDistrict": stakeHolderDetails?.temporaryStorageMasters[0]?.storageDistrict,
            "storageRevenueCircle": stakeHolderDetails?.temporaryStorageMasters[0]?.storageRevenueCircle,
            "storageBlockName": stakeHolderDetails?.temporaryStorageMasters[0]?.storageBlockName,
            "storageSubDivision": stakeHolderDetails?.temporaryStorageMasters[0]?.storageSubDivision,
            "workingCapital": stakeHolderDetails?.temporaryStorageMasters[0]?.workingCapital,
            "isRoadConnectivityValid": stakeHolderDetails?.temporaryStorageMasters[0]?.isRoadConnectivityValid,
            "roadConnectivity": stakeHolderDetails?.temporaryStorageMasters[0]?.roadConnectivity,
            "optedLocationPowerConnectionDistance": stakeHolderDetails?.temporaryStorageMasters[0]?.optedLocationPowerConnectionDistance,
            "isAlternatePowerSupplyAvailable": stakeHolderDetails?.temporaryStorageMasters[0]?.isAlternatePowerSupplyAvailable,
            "daytimePowerAvailability": stakeHolderDetails?.temporaryStorageMasters[0]?.daytimePowerAvailability,
            "gstNumber": stakeHolderDetails?.temporaryStorageMasters[0]?.gstNumber,
            "nonEncumbranceCertificateNo": stakeHolderDetails?.temporaryStorageMasters[0]?.nonEncumbranceCertificateNo,
            "agreementStartDate": stakeHolderDetails?.temporaryStorageMasters[0]?.agreementStartDate,
            "agreementEndDate": stakeHolderDetails?.temporaryStorageMasters[0]?.agreementEndDate,
            "locationGeotag": stakeHolderDetails?.temporaryStorageMasters[0]?.locationGeotag,
            "ownershipType": stakeHolderDetails?.temporaryStorageMasters[0]?.ownershipType,
            "landFillingRequired": stakeHolderDetails?.temporaryStorageMasters[0]?.landFillingRequired,
            "landFillingType": stakeHolderDetails?.temporaryStorageMasters[0]?.landFillingType,
            "existingBoundaryWall": stakeHolderDetails?.temporaryStorageMasters[0]?.existingBoundaryWall,
            "isExistingInfrastructure": stakeHolderDetails?.temporaryStorageMasters[0]?.isExistingInfrastructure,
            "existingInfrastructureOnPlot": stakeHolderDetails?.temporaryStorageMasters[0]?.existingInfrastructureOnPlot,
            "createdOn": stakeHolderDetails?.temporaryStorageMasters[0]?.createdOn,
            "createdBy": stakeHolderDetails?.temporaryStorageMasters[0]?.createdBy,
            "updatedOn": stakeHolderDetails?.temporaryStorageMasters[0]?.updatedOn,
            "updatedBy": stakeHolderDetails?.temporaryStorageMasters[0]?.updatedBy,
            "isActive": stakeHolderDetails?.temporaryStorageMasters[0]?.isActive,
            "documents": stakeHolderDetails?.temporaryStorageMasters[0]?.documents,
            "isMSME": stakeHolderDetails?.isMSME,
            "msmeCategory": stakeHolderDetails?.msmeCategory,
        }
    }

    const isMSMENo =
        isMSMERadio === 0 ||
        isMSMERadio === "NO";


    const filteredDocuments = documentArray?.map(doc => {
        if (doc.documentType === "MSME_Certificate") {
            return {
                ...doc,
                isActive: isMSMENo ? 0 : 1
            };
        }
        return doc;
    });

    let finalData = { ...details };
    finalData.isMSME = isMSMERadio === "YES" ? 1 : 0;
    finalData.msmeCategory = isMSMERadio === "YES" ? msmeCategory : null;

    delete finalData.growerMasters;
    delete finalData.hitMasters;
    delete finalData.lleMasters;
    delete finalData.transporterMasters;
    delete finalData.temporaryStorageMasters;
    let tempStorage = {
        ...details.temporaryStorageDetail, "isMSME": isMSMERadio === "YES" ? 1 : 0,
        "msmeCategory": isMSMERadio === "YES" ? msmeCategory : null, documents: filteredDocuments
    };
    delete tempStorage.regStakeholderMaster;
    finalData.temporaryStorageDetail = tempStorage;

    function updateTempstorage() {

        setDetails(finalData);
        loaderService.showLoader();
        apiClient
            .post(UPDATE_TEMPORARY_STORAGE + `?IsRegistrationSubmit=${getSubmit()}`,
                finalData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                loaderService.hideLoader();
                const updateTempStorageResponse = response?.data
                setCallUpdateApi(false);
                if (updateTempStorageResponse?.isSuccess) {
                    getStakeholderDetailsFromUrn();
                    if (buttonAction === "preview") {
                        setCurrentPage("preview")
                    }
                    if (buttonAction === "submit" || buttonAction === "save") {
                        toast.success(updateTempStorageResponse?.message);
                    }
                    if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
                        onSubmit();
                    }
                    if (buttonAction === "submit") {
                        if (decoded.extension_URN) {
                            navigate('/dashboardHome/dashboardStakeHolder');
                        }
                        else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
                            navigate('/resourcedashboard/searchByURN');
                        }
                        else if (userRole === ROLES.ItAdmin) {
                            navigate('/sidebar/viewAllActiveApplications');
                        }
                        else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
                            navigate('/registrationHome/dashboard');
                        }
                        else if (userRole === ROLES.RegistrationScruitnizer) {
                            setCallWorkFlowApi(true);
                        }
                        else {
                            navigate(-1);
                        }
                    }
                }
                else {
                    toast.error(updateTempStorageResponse?.message);
                    setCurrentPage("registrationDetailsTempStorage")
                }
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }

    const onSubmit = () => {
        loaderService.showLoader();
        apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
            {
                "stakeholderMappings": [
                    {
                        "scrutinizerId": getLocalStorageItem('uuid'),
                        "stakeholderID": stakeHolderDetails?.id,
                        "stakeholderState": stakeHolderDetails?.temporaryStorageMasters?.[0]?.state,
                        "stakeholderDistrict": stakeHolderDetails?.temporaryStorageMasters?.[0]?.district,
                        "loggedInUserID": getLocalStorageItem('uuid'),
                        "isActive": 1,
                        // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                    }
                ]
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    onActionWorflowSubmit();
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const onActionWorflowSubmit = () => {
        loaderService.showLoader();
        apiClient.post(ALLOCATE_WORKFLOW,
            {
                "stakeHolderMasterID": stakeHolderDetails?.id,
                "workflowInitiatorID": getLocalStorageItem('uuid'),
                "workflowReceiverID": "",
                "workflowAction": "Approve",
                "status": "",
                "isStakeHolderAction": false,
                "workflowInitiatorRole": localStorage.getItem('role'),
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    toast.success(response.data?.message);
                    if (localStorage.getItem('uuid'))
                        navigate('/registrationHome/dashboard');
                    else
                        navigate('/dashboardHome/dashboardStakeHolder');
                } else {
                    toast.error(response.data?.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();

            });
    };

    const onGoBack = () => {
        setCurrentPage("registrationDetailsTempStorage")
    }

    return (
        <TempStorageContext.Provider value={{
            viewOnly: state?.viewOnly, regScruResourceUpdate, setRegScruResourceUpdate, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, financeDetailsSectionOk, setFinanceDetailsSectionOk, locationDetailsSectionOk, setLocationDetailsSectionOk, shouldActOnSection, setShouldActOnSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated: state?.registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, setCallUpdateApi, setCallUpdateApi, callWorkFlowApi, isMSMERadio,
            setIsMSMERadio,
            msmeCategory,
            setMsmeCategory,
        }}>
            <>
                {currentPage === "registrationDetailsTempStorage" && details && <Container maxWidth="xxl" >
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG17</p>}
                    <Stack direction="row" alignItems="center" spacing={1} mb={3}>
                        <BackButton navigate={navigate} />
                        <Typography variant="h5" gutterBottom>
                            {t('reg.registrationDetails')}
                        </Typography>
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={4} lg={12}>
                            <TextField
                                required
                                disabled
                                type="text"
                                label="URN"
                                value={urn || ''}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion mt={1} expanded={expandedSection === "personal"}
                                onChange={(event, expanded) => {
                                    setExpandedSection(expanded ? "personal" : "");
                                }}>
                                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                >
                                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                                        {showCommentSection && !regScruResourceUpdate && (personalDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                        <Typography variant="subtitle1">{selectedApplicant === "Individual" ? t('preReg.personalDetails') : t('preReg.organizationDetails')}</Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                {t('preReg.applicantType')}
                                            </Typography>
                                            <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                                                color="primary"
                                                value={selectedApplicant}
                                                exclusive
                                                onChange={(e) => onApplicantClick(e)}
                                                aria-label="Platform"
                                            >
                                                <ToggleButton name="applicantType" value="Individual" disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}>{t('preReg.individual')}</ToggleButton>
                                                <ToggleButton name="applicantType" value="Partnership" disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}>{t('preReg.partnership')}</ToggleButton>
                                                <ToggleButton name="applicantType" value="Proprietorship" disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}>{t('preReg.proprietorship')}</ToggleButton>
                                                <ToggleButton name="applicantType" value="Company" disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}>{t('preReg.company')}</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Grid>
                                        <Grid item xs={12} lg={6} mt={2}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.fullNameError}
                                                helperText={errorMessage.fullNameError}
                                                type="text"
                                                label={t('preReg.applicantName')}
                                                name="name"
                                                value={details.name}
                                                onChange={(e) => handleChange(e)}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                inputProps={{
                                                    maxLength: 50,

                                                }}
                                            />
                                        </Grid>
                                        {selectedApplicant !== "Individual" && (
                                            <Grid item xs={12} lg={2}>
                                                <FormControl>
                                                    <FormLabel sx={{ fontWeight: 600 }}>
                                                        Is MSME?
                                                    </FormLabel>

                                                    <ToggleButtonGroup
                                                        exclusive
                                                        value={isMSMERadio}
                                                        onChange={(e, value) => value && setIsMSMERadio(value)}
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                        sx={{ mt: 1 }}
                                                    >
                                                        <ToggleButton value="YES">Yes</ToggleButton>
                                                        <ToggleButton value="NO">No</ToggleButton>
                                                    </ToggleButtonGroup>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {selectedApplicant !== "Individual" && isMSMERadio === "YES" && (
                                            <Grid item xs={12} lg={4} mt={3}>
                                                <FormControl fullWidth>
                                                    <InputLabel>MSME Category</InputLabel>
                                                    <Select
                                                        label="MSME Category"
                                                        value={msmeCategory}
                                                        onChange={(e) => setMsmeCategory(e.target.value)}
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                    >
                                                        {MSME_CATEGORY_OPTIONS.map(option => (
                                                            <MenuItem key={option.key} value={option.key}>
                                                                <strong>{option.key}</strong> — {option.description}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {selectedApplicant !== "Individual" && isMSMERadio === "YES" && (
                                            <Grid item xs={12} lg={6} mt={1}>
                                                <FileUploadMUI
                                                    key="MSME_Certificate"
                                                    documentList={documentArray}
                                                    documentType="MSME_Certificate"
                                                    callBackDocumentUpload={onUploadCallBack}
                                                    stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                    title="Upload MSME Certificate"
                                                    stakeholderType="temporaryStorage"
                                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                    errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="msmeDocError"
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                                {t('preReg.contactPersonDetails')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <FormControl fullWidth>
                                                <InputLabel>{t('preReg.salutation')}</InputLabel>
                                                <Select
                                                    label={t('preReg.salutation')}
                                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                    name='contactPersonSalutation'
                                                    onChange={(e) => handleChange(e)}
                                                    value={details.contactPersonSalutation}>
                                                    {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={8} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.contactPersonNameError}
                                                helperText={errorMessage.contactPersonNameError}
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                label={t('preReg.firstname')}
                                                inputProps={{
                                                    maxLength: maxNameLength

                                                }}
                                                name="contactPersonFirstname"
                                                value={details.contactPersonFirstname}
                                                onChange={(e) => handleChange(e)}
                                            />

                                            <BadgeComponent currentLength={details?.contactPersonFirstname?.length} maxLength={maxNameLength} />
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <TextField fullWidth
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                label={t("preReg.middlename")}
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                name="contactPersonMiddlename"
                                                value={details.contactPersonMiddlename}
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <BadgeComponent currentLength={details?.contactPersonMiddlename?.length} maxLength={maxNameLength} />
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <TextField fullWidth
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                label={t('preReg.lastname')}
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                name="contactPersonLastname"
                                                value={details.contactPersonLastname}
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <BadgeComponent currentLength={details?.contactPersonLastname?.length} maxLength={maxNameLength} />
                                        </Grid>
                                        <Grid item xs={4} lg={2}>
                                            <FormControl fullWidth>
                                                <InputLabel>{t('preReg.gender')}</InputLabel>
                                                <Select
                                                    label={t('preReg.gender')}
                                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                    name='contactPersonGender'
                                                    onChange={(e) => handleChange(e)}
                                                    value={details.contactPersonGender}>
                                                    {GENDER.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={8} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.mobileNoError}
                                                helperText={errorMessage.mobileNoError}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label={t('preReg.mobileNo')}
                                                name="mobileNo"
                                                inputProps={{
                                                    maxLength: 10
                                                }}
                                                onKeyDown={(evt) => typeNumberValid(evt)}
                                                value={details.mobileNo}
                                                onChange={(e) => handleChange(e)}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                            {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                                <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.emailIdError}
                                                helperText={errorMessage.emailIdError}
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                label={t('main.email')}
                                                name="emailId"
                                                inputProps={{
                                                    style: { textTransform: "none" }
                                                }}
                                                value={details.emailId}
                                                onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                        </Grid>
                                        { }
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.panNumberError}
                                                helperText={errorMessage.panNumberError}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                type="text"
                                                label={t('preReg.enterPanNo')}
                                                maxLength={10}
                                                name="panNumber"
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                value={details.panNumber}
                                                onChange={(e) => handleChange(e)} />
                                            <FileUploadMUI key="PANCard"
                                                documentList={documentArray}
                                                documentType="PANCard"
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadPanDoc')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="panDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}

                                        </Grid>
                                        {selectedApplicant === 'Individual' ?
                                            <>
                                                <Grid item xs={6} lg={4}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('preReg.addressProof')}</InputLabel>
                                                        <Select
                                                            label={t('preReg.addressProof')}
                                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                            name="govtIdCardType"
                                                            value={details.govtIdCardType}
                                                            onChange={(e) => handleChange(e)}
                                                        >
                                                            {GOV_ID_LIST.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}

                                                        </Select>
                                                    </FormControl>
                                                    <FileUploadMUI key="IDProof"
                                                        documentList={documentArray}
                                                        documentType="IDProof"
                                                        callBackDocumentUpload={onUploadCallBack}
                                                        stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                        title="Upload IDProof Document"
                                                        stakeholderType="temporaryStorage"
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                        errorMessage={errorMessage}
                                                        setErrorMessage={setErrorMessage}
                                                        documentError="idProofDocError"
                                                    />
                                                    {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}

                                                </Grid>
                                                <Grid item xs={6} lg={4}>
                                                    <TextField fullWidth
                                                        error={errorMessage.idCardNumberError}
                                                        helperText={errorMessage.idCardNumberError}
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                        type="text"
                                                        name="govtIdCardNumber"
                                                        label={details.govtIdCardType === "Aadhaar ID" ? t('preReg.enterLast4digit') : details.govtIdCardType === "Voter ID" ? t('preReg.enterVoterId') : details.govtIdCardType === "Driving Licence" ? t('preReg.enterDrivinglicense') : t('preReg.enterBankPassbookNo')}
                                                        value={details.govtIdCardNumber}
                                                        onChange={(e) => handleChange(e)}
                                                        inputProps={{
                                                            style: { textTransform: "uppercase" }
                                                        }}
                                                    />
                                                    <BadgeComponent currentLength={details?.govtIdCardNumber?.length} maxLength={details.govtIdCardType === "Aadhaar ID" ? lastFourDigit : govtIDcardLength} />
                                                </Grid>
                                            </> :
                                            <>
                                                <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6} lg={4}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('preReg.idProof')}</InputLabel>
                                                        <Select
                                                            label={t('preReg.idProof')}
                                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                            name="govtIdCardType"
                                                            value={details.govtIdCardType}
                                                            onChange={(e) => handleChange(e)}
                                                        >
                                                            <MenuItem disabled> ID Proof</MenuItem>
                                                            {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}

                                                        </Select>
                                                    </FormControl>
                                                    <FileUploadMUI key="IDProof"
                                                        documentList={documentArray}
                                                        documentType="IDProof"
                                                        callBackDocumentUpload={onUploadCallBack}
                                                        stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                        title="Upload IDProof Document"
                                                        stakeholderType="temporaryStorage"
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                        errorMessage={errorMessage}
                                                        setErrorMessage={setErrorMessage}
                                                        documentError="idProofDocError"
                                                    />
                                                    {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}

                                                </Grid>
                                                {details.govtIdCardType == "Other" &&
                                                    <Grid item xs={6} lg={4}>
                                                        <TextField fullWidth
                                                            error={errorMessage.otherCardError}
                                                            helperText={errorMessage.otherCardError}
                                                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                            type="text"
                                                            label={t('preReg.enterIdProof')}
                                                            name="otherGovtCardType"
                                                            value={details?.otherGovtCardType}
                                                            onChange={(e) => handleChange(e)}
                                                            inputProps={{
                                                                style: { textTransform: "uppercase" }
                                                            }} />
                                                    </Grid>}
                                                <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6} lg={4}>
                                                    <TextField fullWidth
                                                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                                                        error={errorMessage.idCardNumberError}
                                                        helperText={errorMessage.idCardNumberError}
                                                        type="text"
                                                        name="govtIdCardNumber"
                                                        inputProps={{
                                                            style: { textTransform: "uppercase" }
                                                        }}
                                                        label={details.govtIdCardType === "MOA" ? t('preReg.enterMOA') : details.govtIdCardType === "Registration Certificate" ? t('preReg.enterRegNo') : details.govtIdCardType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                                                        defaultValue={details.govtIdCardNumber}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                    <BadgeComponent currentLength={details?.govtIdCardNumber?.length} maxLength={govtIDcardLength} />
                                                </Grid>
                                            </>}
                                        <Grid item xs={12}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.addressError}
                                                helperText={errorMessage.addressError}
                                                disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                                type="text"
                                                label={t('main.officeAddressTitle')}
                                                name="officeAddress"
                                                multiline

                                                value={details.temporaryStorageDetail.officeAddress}
                                                onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.temporaryStorageDetail?.officeAddress?.length} maxLength={addressMaxLength} />
                                        </Grid>
                                        <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                            fullWidth={true} t
                                            revenueNotRequired={true}
                                            pincode={details.temporaryStorageDetail?.officePincode}
                                            state={details.temporaryStorageDetail?.officeState}
                                            district={details.temporaryStorageDetail?.officeDistrict}
                                            revenueCircle={details.temporaryStorageDetail?.officeRevenueCircle}
                                            blockName={details.temporaryStorageDetail?.officeBlockName}
                                            onHandleCallback={setOfficeAddressData}
                                            pincodeError={errorMessage.pincodeError}
                                            searchError={errorMessage.searchError}
                                            handleChangeSelect={handleOfficeChangeSelect}
                                            isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        />
                                    </Grid>
                                    {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <TextField sx={{ width: "100%" }}
                                                label={t('reg.comment')}
                                                helperText={errorMessage.personalCommentError}
                                                error={errorMessage.personalCommentError}
                                                name="comment"
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                                multiline
                                                disabled={!shouldActOnSection.personal_details || state?.viewOnly}
                                                value={personalComment}
                                                onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                            />
                                            {/* <BadgeComponent currentLength={details?.personalComment?.length} maxLength={approverCommentMaxLength} /> */}
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || state?.viewOnly} checked={personalDetailsSectionOk}
                                                    onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                        {t('reg.detailsOk')}?
                                                    </Typography>} />
                                            </FormGroup>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button variant="contained" disabled={!shouldActOnSection.personal_details || state?.viewOnly}
                                                onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                                                startIcon={<CommentIcon />}
                                            >
                                                {t('preReg.addComment')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                        <div>
                                            <Accordion mt={1} >
                                                <AccordionSummary
                                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                >
                                                    <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box style={{ height: 300, width: '100%' }}>
                                                        <DataGrid
                                                            rows={personalComments ? personalComments : []}
                                                            columns={commentsColumn}
                                                            pageSize={10}
                                                            getRowHeight={() => 'auto'} />
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div></>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion mt={1} expanded={expandedSection === "bank"}
                                onChange={(event, expanded) => {
                                    setExpandedSection(expanded ? "bank" : "");
                                }}>
                                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                >
                                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                                        {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                        <Typography variant="subtitle1">{t('preReg.bankDetails')}</Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.bankAccountError}
                                                helperText={errorMessage.bankAccountError}
                                                disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                name="bankAccountNumber"
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                label={t('preReg.accountNo')}
                                                value={details.bankAccountNumber}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            />
                                            <BadgeComponent currentLength={details?.bankAccountNumber?.length} maxLength={bankAccountNumber} />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.accountHolderNameError}
                                                helperText={errorMessage.accountHolderNameError}
                                                disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                                type="text"
                                                name="bankAccountHolderName"
                                                label={t('preReg.accountHolderName')}
                                                value={details.bankAccountHolderName}
                                                onChange={(e) => handleChange(e)}
                                                maxLength={maxNameLength}
                                            />
                                            <BadgeComponent currentLength={details?.bankAccountHolderName?.length} maxLength={maxNameLength} />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.ifscError}
                                                helperText={errorMessage.ifscError}
                                                disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                                type="text"
                                                name="bankIfscCode"
                                                maxLength={11}
                                                label={t('preReg.ifscCode')}
                                                value={details.bankIfscCode}
                                                onChange={(e) => handleChange(e)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton color="primary" aria-label="search"
                                                                disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                                                onClick={() => getBankDetails()} >
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    maxLength: 11,
                                                    style: { textTransform: "uppercase" }
                                                }}
                                            >
                                                <BadgeComponent currentLength={details?.bankIfscCode?.length} maxLength={govtIDcardLength} />
                                            </TextField>
                                            <FileUploadMUI key={BANK_CANCELLED_CHEQUE}
                                                documentList={documentArray}
                                                documentType={BANK_CANCELLED_CHEQUE}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadPassbookCancelledCheck')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="bankDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                disabled
                                                required
                                                type="text"
                                                name="bankBranch"
                                                label={t('preReg.branch')}
                                                value={details.bankBranch}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                onChange={(e) => handleChange(e)}
                                            />
                                        </Grid>
                                    </Grid>
                                    {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <TextField sx={{ width: "100%" }}
                                                label={t('reg.comment')}
                                                helperText={errorMessage.bankCommentError}
                                                error={errorMessage.bankCommentError}
                                                name="comment"
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                                multiline
                                                disabled={!shouldActOnSection.bank_details || state?.viewOnly}
                                                value={bankComment}
                                                onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || state?.viewOnly} checked={bankDetailsSectionOk}
                                                    onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                        {t('reg.detailsOk')}?
                                                    </Typography>} />
                                            </FormGroup>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button variant="contained" disabled={!shouldActOnSection.bank_details || state?.viewOnly}
                                                onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                                                startIcon={<CommentIcon />}
                                            >
                                                {t('preReg.addComment')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                        <div>
                                            <Accordion mt={1} >
                                                <AccordionSummary
                                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                >
                                                    <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box style={{ height: 300, width: '100%' }}>
                                                        <DataGrid
                                                            rows={bankComments ? bankComments : []}
                                                            columns={commentsColumn}
                                                            pageSize={10}
                                                            getRowHeight={() => 'auto'} />
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div></>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion mt={1} expanded={expandedSection === "agreement"}
                                onChange={(event, expanded) => {
                                    setExpandedSection(expanded ? "agreement" : "");
                                }}>
                                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                >
                                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                                        {showCommentSection && !regScruResourceUpdate && (agreementDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                        <Typography variant="subtitle1">{t('preReg.licenseAgreementDetails')}</Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        // required
                                                        // error={errorMessage.agreementSatrtDateError}
                                                        // helperText={errorMessage.agreementSatrtDateError}
                                                        label={t('preReg.agreementStartDate')}
                                                        inputFormat="DD/MM/YYYY"
                                                        value={agreementStartDateDisplay}
                                                        name="startDate"
                                                        onChange={(e) => handleDateChange(e, "startDate")}
                                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ paddingRight: '3%' }}
                                                        componentsProps={{
                                                            actionBar: { actions: ['clear'], }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementSatrtDateError}</FormHelperText>

                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        // required
                                                        // error={errorMessage.agreementEndDateError}
                                                        // helperText={errorMessage.agreementEndDateError}
                                                        inputFormat="DD/MM/YYYY"
                                                        minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                        label={t('preReg.agreementEndDate')}
                                                        name="endDate"
                                                        value={agreementEndDateDisplay}
                                                        onChange={(e) => handleDateChange(e, "endDate")}
                                                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                        renderInput={(params) => <TextField {...params} />}
                                                        sx={{ paddingRight: '3%' }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                            <FileUploadMUI key={LOI_ABRPL_AGREEMENT}
                                                documentList={documentArray}
                                                documentType={LOI_ABRPL_AGREEMENT}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadLoiAgreement')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="agreementDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.agreementDocError}</div> */}

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.gstError}
                                                helperText={errorMessage.gstError}
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                name="gstNumber"
                                                label={t('preReg.gstNo')}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                value={details.temporaryStorageDetail.gstNumber}
                                                onChange={(e) => handleChange(e)} />
                                            <FileUploadMUI key={GST}
                                                documentList={documentArray}
                                                documentType={GST}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadGst')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="gstDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.gstDocError}</div> */}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.nonEncumCertError}
                                                helperText={errorMessage.nonEncumCertError}
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                name="nonEncumbranceCertificateNo"
                                                label={t('preReg.nonEcumbranceCertificateNo')}
                                                value={details.temporaryStorageDetail.nonEncumbranceCertificateNo}
                                                onChange={(e) => handleChange(e)} />
                                            <FileUploadMUI key={NON_ENCUMBRANCE_CERTI}
                                                documentList={documentArray}
                                                documentType={NON_ENCUMBRANCE_CERTI}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadNonEcumbraceDoc')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="nonEncumDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.nonEncumDocError}</div> */}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FileUploadMUI key={VALATION_REPORT}
                                                documentList={documentArray}
                                                documentType={VALATION_REPORT}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadValuationDueDiligence')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="valuationDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.valuationDocError}</div> */}
                                        </Grid>
                                    </Grid>
                                    {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <TextField sx={{ width: "100%" }}
                                                label={t('reg.comment')}
                                                helperText={errorMessage.agreementCommentError}
                                                error={errorMessage.agreementCommentError}
                                                name="comment"
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                                multiline
                                                disabled={!shouldActOnSection.agreement_details || state?.viewOnly}
                                                value={agreementComment}
                                                onChange={(e) => setAgreementComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${agreementComment?.length > characterLimit ? 'danger' : 'primary'}`}>{agreementComment?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch disabled={!shouldActOnSection.agreement_details || state?.viewOnly} checked={agreementDetailsSectionOk}
                                                    onChange={(e) => setAgreementDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                        {t('reg.detailsOk')}?
                                                    </Typography>} />
                                            </FormGroup>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button variant="contained" disabled={!shouldActOnSection.agreement_details || state?.viewOnly}
                                                onClick={() => onSaveComment(agreementComment, "agreement_details", agreementDetailsSectionOk)}
                                                startIcon={<CommentIcon />}
                                            >
                                                {t('preReg.addComment')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                        <div>
                                            <Accordion mt={1} >
                                                <AccordionSummary
                                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                >
                                                    <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box style={{ height: 300, width: '100%' }}>
                                                        <DataGrid
                                                            rows={agreementComments ? agreementComments : []}
                                                            columns={commentsColumn}
                                                            pageSize={10}
                                                            getRowHeight={() => 'auto'} />
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div></>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion mt={1} expanded={expandedSection === "finance"}
                                onChange={(event, expanded) => {
                                    setExpandedSection(expanded ? "finance" : "");
                                }}>
                                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (financeDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                >
                                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                                        {showCommentSection && !regScruResourceUpdate && (financeDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                        <Typography variant="subtitle1">Financial Information</Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (financeDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                        <Grid item xs={12}>
                                            {/* <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                                {t('preReg.financialInformation')}
                                            </Typography> */}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.netWorthError}
                                                helperText={errorMessage.netWorthError}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                disabled={!enableFieldFunction(shouldActOnSection.finance_details, true)}
                                                label={t('preReg.networth')}
                                                name="netWorth"
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                value={details.temporaryStorageDetail.netWorth}
                                                onChange={(e) => handleChange(e)} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.workingCapitalError}
                                                helperText={errorMessage.workingCapitalError}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label={t('preReg.workingCapital')}
                                                disabled={!enableFieldFunction(shouldActOnSection.finance_details, true)}
                                                name="workingCapital"
                                                inputProps={{
                                                    maxLength: maxNameLength
                                                }}
                                                value={details.temporaryStorageDetail.workingCapital}
                                                onChange={(e) => handleChange(e)} />
                                        </Grid>
                                    </Grid>
                                    {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <TextField sx={{ width: "100%" }}
                                                label={t('reg.comment')}
                                                helperText={errorMessage.financeCommentError}
                                                error={errorMessage.financeCommentError}
                                                name="comment"
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                                multiline
                                                disabled={!shouldActOnSection.finance_details || state?.viewOnly}
                                                value={financeComment}
                                                onChange={(e) => setFinanceComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${financeComment?.length > characterLimit ? 'danger' : 'primary'}`}>{financeComment?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || state?.viewOnly} checked={financeDetailsSectionOk}
                                                    onChange={(e) => setFinanceDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                        {t('reg.detailsOk')}?
                                                    </Typography>} />
                                            </FormGroup>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button variant="contained" disabled={!shouldActOnSection.personal_details || state?.viewOnly}
                                                onClick={() => onSaveComment(financeComment, "finance_details", financeDetailsSectionOk)}
                                                startIcon={<CommentIcon />}
                                            >
                                                {t('preReg.addComment')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                        <div>
                                            <Accordion mt={1} >
                                                <AccordionSummary
                                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                >
                                                    <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box style={{ height: 300, width: '100%' }}>
                                                        <DataGrid
                                                            rows={financeComments ? financeComments : []}
                                                            columns={commentsColumn}
                                                            pageSize={10}
                                                            getRowHeight={() => 'auto'} />
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div></>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion mt={1} expanded={expandedSection === "location"}
                                onChange={(event, expanded) => {
                                    setExpandedSection(expanded ? "location" : "");
                                }}>
                                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (locationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                >
                                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                                        {showCommentSection && !regScruResourceUpdate && (locationDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                        <Typography variant="subtitle1">{t('preReg.informationAboutOptedLocation')}</Typography>
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (locationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                                        <Grid item xs={12}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.locationAddressError}
                                                helperText={errorMessage.locationAddressError}
                                                type="text"
                                                disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                label={t('preReg.fullAddress')}
                                                multiline
                                                inputProps={{
                                                    maxLength: addressMaxLength
                                                }}
                                                name="storageAddress"
                                                value={details.temporaryStorageDetail.storageAddress} onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.temporaryStorageDetail?.storageAddress?.length} maxLength={addressMaxLength} />
                                        </Grid>
                                        <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                            fullWidth={true}
                                            revenueNotRequired={true}
                                            pincode={details.temporaryStorageDetail?.storagePincode}
                                            state={details.temporaryStorageDetail?.storageState}
                                            district={details.temporaryStorageDetail?.storageDistrict}
                                            revenueCircle={details.temporaryStorageDetail?.storageRevenueCircle}
                                            blockName={details.temporaryStorageDetail?.storageBlockName}
                                            onHandleCallback={setStorageAddressData}
                                            pincodeError={errorMessage.locationPincodeError}
                                            searchError={errorMessage.locationSearchError}
                                            handleChangeSelect={handleStorageChangeSelect}
                                            isDisabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                        />
                                        <Grid item xs={12}>
                                            <LocationPointMUI
                                                latitudeLabel="Latitude"
                                                longitudeLabel="Longitude"
                                                latitudeName={t('preReg.latitude')}
                                                longitudeName={t('preReg.longitude')}
                                                latitude={details?.temporaryStorageDetail?.latitude}
                                                longitude={details?.temporaryStorageDetail?.longitude}
                                                callBackLocation={onLocationPoint}
                                                isDisabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                latitudesError={errorMessage.latitudesError}
                                                longitudesError={errorMessage.longitudesError}
                                            />
                                            <FileUploadMUI key={GEOCODE_LOCATION}
                                                documentList={documentArray}
                                                documentType={GEOCODE_LOCATION}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="locationDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.locationDocError}</div> */}

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.landAreaError}
                                                helperText={errorMessage.landAreaError}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                min="0"
                                                disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                label={t('preReg.landArea')}
                                                name="landArea"
                                                value={landArea}
                                                onChange={(e) => handleChange(e)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <Select
                                                            variant="standard"
                                                            size="small"
                                                            disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                            value={landAreaUnit}
                                                            name="landAreaUnit"
                                                            onChange={(e) => handleChange(e)}>
                                                            {LAND_AREA_UNIT.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                        </Select>
                                                    ),
                                                    maxLength: 6
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <Typography variant="subtitle1" gutterBottom>{t('preReg.ownnershipType')}</Typography>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                >
                                                    <FormControlLabel control={<Radio name="Owned_type" checked={ownershipType === "Owned"} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e, true)} />} label={t('preReg.owned')} value="Owned" />
                                                    <FormControlLabel control={<Radio name="Owned_type" checked={ownershipType === "Leased"} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e, false)} />} label={t('preReg.lease')} value="Leased" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FileUploadMUI key={LAND_DOCUMENT}
                                                documentList={documentArray}
                                                documentType={LAND_DOCUMENT}
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={ownershipType === "Leased" ? t('preReg.uploadJamabandiReceiptLandOwnerTax') : t('preReg.uploadJamabandiKhajnaTax')}
                                                stakeholderType="temporaryStorage"
                                                disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="landDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.landDocError}</div> */}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.roadConnectivity')} :
                                            </Typography>
                                            <Typography variant="body2" gutterBottom>
                                                {t('preReg.roadConnectivityDescrip')}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>{t('preReg.optedPlotIs')}</Typography>

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Adjacent to an existing bitumen/block road"} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToBitumenBlockRoad')} value="Adjacent to an existing bitumen/block road" />
                                                <br />
                                                <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Adjacent to an existing motorable gravel road"} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToMotorableGravelRoad')} value="Adjacent to an existing motorable gravel road" />
                                                <br />
                                                <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Requires additional road development less than 500 meters"} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.requireAdditionalRoad')} value="Requires additional road development less than 500 meters" />
                                            </RadioGroup>

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.powerConnectivity')} :
                                            </Typography>
                                            <Typography variant="body2" gutterBottom>
                                                {t('preReg.distanceFromDistribution')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>{t('preReg.powerConnectionAvailable')} :</Typography>
                                            <RadioGroup
                                                column
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === WITHIN_100_METER} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.within100mtr')} value={WITHIN_100_METER} />
                                                <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === BTWN_100_500_METER} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn100_500mtr')} value={BTWN_100_500_METER} />
                                                <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === BTWN_500_1_METER} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn500mtr_1km')} value={BTWN_500_1_METER} />
                                            </RadioGroup>

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.daytimePowerAvailability')} :
                                            </Typography>
                                            <Typography variant="body2" gutterBottom>
                                                {t('preReg.powerAvailabilityDescrip')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>{t('preReg.powerAvailableFor')} :</Typography>
                                            <RadioGroup
                                                column
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === MORE_THAN_8_HR} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.moreThan8hour')} value={MORE_THAN_8_HR} />
                                                <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === BTWN_6_8_HR} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn6_8hour')} value={BTWN_6_8_HR} />
                                                <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === BTWN_4_6_HR} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn4_6hour')} value={BTWN_4_6_HR} />
                                            </RadioGroup>

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.landFillingRequired')} :
                                            </Typography>

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="landFillingRequired" checked={details.temporaryStorageDetail?.landFillingRequired === true} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                                <br />
                                                <FormControlLabel control={<Radio name="landFillingRequired" checked={details.temporaryStorageDetail?.landFillingRequired === false} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                            </RadioGroup>

                                        </Grid>
                                        {details.temporaryStorageDetail?.landFillingRequired === true &&
                                            <Grid item xs={12} lg={6}>
                                                <RadioGroup
                                                    column
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                >
                                                    <FormControlLabel control={<Radio name="landFillingType" checked={details.temporaryStorageDetail?.landFillingType === LESS_THAN_2_FEET} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={LESS_THAN_2_FEET} value={LESS_THAN_2_FEET} />
                                                    <FormControlLabel control={<Radio name="landFillingType" checked={details.temporaryStorageDetail?.landFillingType === MORE_THAN_2_FEET} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={MORE_THAN_2_FEET} value={MORE_THAN_2_FEET} />
                                                </RadioGroup>
                                            </Grid>
                                        }
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.existingBoundaryFenceOrWall')} :
                                            </Typography>

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="existingBoundary" checked={details.temporaryStorageDetail?.existingBoundaryWall === true} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                                <br />
                                                <FormControlLabel control={<Radio name="existingBoundary" checked={details.temporaryStorageDetail?.existingBoundaryWall === false} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                            </RadioGroup>

                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                {t('preReg.anyExistingInfraOnPlot')} :
                                            </Typography>

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="isExistingInfrastructure" checked={details.temporaryStorageDetail?.isExistingInfrastructure === true} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                                <br />
                                                <FormControlLabel control={<Radio name="isExistingInfrastructure" checked={details.temporaryStorageDetail?.isExistingInfrastructure === false} disabled={!enableFieldFunction(shouldActOnSection.location_details, true)} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                            </RadioGroup>

                                        </Grid>
                                        {details.temporaryStorageDetail?.isExistingInfrastructure === true &&
                                            <Grid item xs={12} lg={6}>
                                                <TextField fullWidth
                                                    type="text"
                                                    disabled={!enableFieldFunction(shouldActOnSection.location_details, true)}
                                                    label={t('preReg.existingInfrastructure')} name="existingInfrastructureOnPlot"
                                                    inputProps={{
                                                        maxLength: 200
                                                    }}
                                                    value={details.temporaryStorageDetail.existingInfrastructureOnPlot}
                                                    onChange={(e) => handleChange(e)} />
                                            </Grid>
                                        }
                                    </Grid>
                                    {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                        <Grid item xs={8}>
                                            <TextField sx={{ width: "100%" }}
                                                label={t('reg.comment')}
                                                helperText={errorMessage.locationCommentError}
                                                error={errorMessage.locationCommentError}
                                                name="comment"
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                                multiline
                                                disabled={!shouldActOnSection.location_details || state?.viewOnly}
                                                value={locationComment}
                                                onChange={(e) => setLocationComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${locationComment?.length > characterLimit ? 'danger' : 'primary'}`}>{locationComment?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch disabled={!shouldActOnSection.location_details || state?.viewOnly} checked={locationDetailsSectionOk}
                                                    onChange={(e) => setLocationDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                                                        {t('reg.detailsOk')}?
                                                    </Typography>} />
                                            </FormGroup>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Button variant="contained" disabled={!shouldActOnSection.location_details || state?.viewOnly}
                                                onClick={() => onSaveComment(locationComment, "location_details", locationDetailsSectionOk)}
                                                startIcon={<CommentIcon />}
                                            >
                                                {t('preReg.addComment')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                        <div>
                                            <Accordion mt={1} >
                                                <AccordionSummary
                                                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                >
                                                    <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Box style={{ height: 300, width: '100%' }}>
                                                        <DataGrid
                                                            rows={locationComments ? locationComments : []}
                                                            columns={commentsColumn}
                                                            pageSize={10}
                                                            getRowHeight={() => 'auto'} />
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div></>}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        {!showWorkFlowButtons &&
                            <Button
                                sx={{ minWidth: 100 }}
                                variant="contained"
                                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                                onClick={() => { (!_.isEqual(finalData, initialDataCompare) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                                startIcon={<SaveIcon />}
                            >{t('preReg.save')}
                            </Button>
                        }
                        <Button
                            sx={{ minWidth: 100, ml: 1 }}
                            variant="contained"
                            onClick={() => validateDetails()}
                            startIcon={<PreviewIcon />}
                        >{t('preReg.preview')}</Button>
                    </Box>
                </Container>}
                {currentPage === "preview" &&
                    <Grid xs={12} md={12} id='divPreview'>
                        <Preview urn={urn} goBack={onGoBack} callWorkFlowApi={callWorkFlowApi} stakeholderType="TempStorage" />
                    </Grid>}
            </>
        </TempStorageContext.Provider>
    );
}
export default RegistrationDetailsTempStorage;
export const useTempStorageContextData = () => useContext(TempStorageContext)